import { IMemberDepiction, IMemberServed } from './index.js'

export interface IMember {
  bioguideId: string
  depiction: IMemberDepiction
  district: number
  name: string
  party: string
  served: IMemberServed
  state: string
  url: string
}
